export function MenuEyebrow({ children }: { children: string }) {
  return (
    <p className="font-sans text-[length:var(--menu-fs-xs)] font-semibold uppercase tracking-[0.28em] text-primary">
      {children}
    </p>
  )
}
